import React from 'react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Button({ label, handleClick, full }) {
  return (
    <button
      type="submit"
      onClick={handleClick}
      className={classNames(
        full ? 'w-full' : '',
        'whitespace-nowrap justify-center py-3 px-8 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-500 hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500'
      )}
    >
      {label}
    </button>
  );
}
